export const API_PARAM = {
  TENANTS: "admin/tenants",
  TENANTS_GET: "admin/tenants/{id}",
  TENANTS_GRID: "admin/tenants/grid",
  TENANTS_EXPORT: "admin/tenants/grid/export",
  TENANTS_COL_FILTER: "admin/tenants/grid/values",
  TENANT_RESTORE: "admin/tenants/restore",
  TENANT_CONFIGURATION: "baseline/tenants/{tenantId}/settings/tenant-config",
  TENANT_USER_GRID: "admin/users/{id}/tenants/grid",
  TENANTS_USER_COL_FILTER: "admin/users/{id}/tenants/grid/values",
  TENANT_USER_ROLE: "admin/users/{id}/tenants/{tenantId}",
  TENANT_ROLES: "baseline/tenants/{tenantId}/roles",
  TENANT_USER: "baseline/tenants/{tenantId}/users",
  TENANT_USER_RESTORE: "baseline/tenants/{tenantId}/users/restore",
  TENANT_USER_SUBSCRIPTION:
    "baseline/tenants/{tenantId}/settings/user-subscription-config",
  USERS: "admin/users",
  USER_GET: "admin/users/{id}",
  USERS_GRID: "admin/users/grid",
  USERS_EXPORT: "admin/users/grid/export",
  USERS_COL_FILTER: "admin/users/grid/values",
  USER_ROLES: "admin/roles",
  USER_RESTORE: "admin/users/restore",
  USER_TENANTS: "admin/users/{id}/tenants",
  ADD_EXECUTION_FLOW: "admin/etls",
  EXECUTION_FLOWS_GRID: "admin/etls/grid",
  EXECUTION_FLOWS_COL_FILTER: "admin/etls/grid/values",
  EXECUTION_FLOW_STEP_LOGS_GRID: "admin/etls/{id}/steps/grid",
  EXECUTION_FLOW_TYPES: "admin/etls/flow-types",
  SYNC_TENANT_SKILLS: "baseline/tenants/{tenantId}/settings/sync-tenant-skills",
};
